import Input from "./m-input"

export default {
  name: "Table",
  components: { minput: Input },
  props: ["head", "items", "checkbox"],
  created () {
    this.items = Object.keys(this.items).sort().reverse().reduce(
      (obj, key) => {
        obj[key] = this.items[key];
        return obj;
      },
      {}
    );
  },
  data() {
    return {
      internalValue: null,
    }
  },
  template:
    '<table><thead class="mtable__head"><tr>' +
    '<th v-if="checkbox" class="mtable__head-item"><img src="/assets/images/manager-settings.svg"></th>' +
    '<th class="mtable__head-item" v-for="name in head">{{name}}</th></tr></thead>' +
    '<tbody class="mtable__body">' +
    '<tr v-for="item in items" class="mtable__row">' +
    '<td v-if="checkbox"><minput centered="Y" checkbox="Y" :data-item="item.ID.value"></minput></td>' +
    '<td v-for="value in item" class="mtable__row-item" v-if="value.link"><a :href="value.link">{{value.value}}</a></td>' +
    '<td class="mtable__row-item" v-else>{{value.value}}</td>' +
    "</tr></tbody></table>",
}
